/**
 * Keep the size buttons honest when the colour changes.
 *
 * Symmetry greys an option with `is-unavailable`, rendered by Liquid from
 * `value.available` — which is relative to whatever else is selected. To
 * refresh it after a change, the theme re-requests the section and swaps the
 * markup in.
 *
 * That cannot work here. This product page's section is tc-fitting-room, and
 * it holds app blocks — reviews, the size chart, the add-ons. Shopify's
 * Section Rendering API returns null for any section containing an app block,
 * so the request comes back empty, nothing is swapped, and every option keeps
 * the availability of the colour the page first rendered.
 *
 * On the Ross brogue that meant Navy showed Brown's stock: six of seven sizes
 * greyed while sitting in the warehouse, and the one size offered — UK 7 —
 * the only one actually sold out. Customers were being sent to "notify me"
 * for shoes we could have posted that afternoon.
 *
 * So the page works it out for itself. The full variant map is already
 * published for the fit recommendation; this reads the same map and applies
 * the same rule Liquid would have: a value is available when some variant is
 * available that carries it along with everything else currently chosen.
 */
(function () {
  'use strict';

  function readMap(root) {
    var el = root.querySelector('[data-tcfr-variants]') ||
             document.querySelector('[data-tcfr-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function init(picker) {
    if (picker.__tcStock) return;
    var map = readMap(picker) || readMap(document);
    if (!map || !map.length) return;
    picker.__tcStock = true;

    var groups = [].slice.call(picker.querySelectorAll('.option-selector'));
    if (!groups.length) return;

    function chosenIn(group) {
      var hit = group.querySelector('.js-option:checked, .js-option[aria-selected="true"]');
      return hit ? (hit.value || hit.getAttribute('data-value')) : null;
    }

    function valueOf(input) {
      return input.value || input.getAttribute('data-value') || '';
    }

    function refresh() {
      // What is chosen in every other group — the context a value is judged in.
      var chosen = groups.map(chosenIn);

      groups.forEach(function (group, gi) {
        var inputs = [].slice.call(group.querySelectorAll('.js-option'));
        inputs.forEach(function (input) {
          var value = valueOf(input);
          if (!value) return;

          var ok = map.some(function (variant) {
            if (!variant.available) return false;
            var opts = variant.options || [];
            // Positional where the map lines up with the groups, which it
            // does for a normal product; membership otherwise, so an odd
            // shape degrades to the old behaviour rather than breaking.
            var mine = opts.length === groups.length ? opts[gi] : null;
            if (mine !== null ? mine !== value : opts.indexOf(value) === -1) return false;
            for (var i = 0; i < groups.length; i++) {
              if (i === gi || chosen[i] === null) continue;
              var theirs = opts.length === groups.length ? opts[i] : null;
              if (theirs !== null ? theirs !== chosen[i] : opts.indexOf(chosen[i]) === -1) return false;
            }
            return true;
          });

          input.classList.toggle('is-unavailable', !ok);
          // custom-select renders options as elements, not inputs
          var opt = input.closest('.custom-select__option');
          if (opt) opt.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    // The theme swaps its own classes around on change too, so run after it.
    picker.addEventListener('change', function () { setTimeout(refresh, 0); });
    picker.addEventListener('click', function (e) {
      if (e.target.closest('.js-option, .opt-label, .custom-select__option')) setTimeout(refresh, 30);
    });
    refresh();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('variant-picker')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
